<div appNavigateBack
    class="text-primary cursor-pointer d-inline-flex align-items-center py-2 px-1"
    (click)="onButtonClick()">
  <i class="mdi mdi-24px mdi-chevron-left"></i>
  <strong>{{ 'GENERAL.BACK_BTN' | translate }}</strong>
</div>
